<template>
    <asset-register-assignment-setup 
        :dialog="dialog" 
        :data="assignmentFormData" 
        @update:dialog="dialog = $event" 
    />  
    <asset-register-unassignment-setup 
        :dialog="unassignmentDialog" 
        :data="unassignmentFormData" 
        @update:dialog="unassignmentDialog = $event" 
    />  
    <v-window-item value="assignments">
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <div class="d-flex justify-space-between align-center mb-4">
                        <h2 class="text-h6">Asset Assignments</h2>
                        <v-btn
                            @click="openAssetAssignment"
                            color="primary"
                            variant="tonal"
                            prepend-icon="mdi mdi-plus"
                            rounded="xl"
                        >
                            Add Asset Assignment
                        </v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" class="pa-1">
                    <v-data-table
                    :headers="assignmentsHeaders"
                    :items="assignmentsData"
                    :loading="loading"
                    :hover="true"
                    density="compact"
                    elevation="0"
                    class="border-sm rounded-md"
                    >
                        <template v-slot:item.status="{ item }">
                            <v-chip
                            v-if="item.status == 1"
                            color="success"
                            size="small"
                            class="text-capitalize">
                                Active
                            </v-chip>

                            <v-chip
                            v-else
                            color="red"
                            size="small"
                            class="text-capitalize">
                                Inactive
                            </v-chip>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-btn 
                            icon 
                            size="small" 
                            variant="text" 
                            color="orange"
                            @click="editAssignment(item)"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>

                            <v-btn 
                            v-if="!item.end_date"
                            icon 
                            size="small" 
                            variant="text" 
                            color="red-accent-3"
                            @click="updateAssignmentDate(item)"
                            >
                                <v-icon>mdi-location-exit</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-window-item>
</template>

<script>
import assetRegisterAssignmentSetup from '@/components/module/asset/assetRegistration/assetRegisterAssignments/assetRegisterAssignmentSetup.vue';
import assetRegisterUnassignmentSetup from '@/components/module/asset/assetRegistration/assetRegisterAssignments/assetRegisterUnassignmentSetup.vue';
export default {
    props: {
        assignmentsData: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
        }
    },
    components: {
        assetRegisterAssignmentSetup,
        assetRegisterUnassignmentSetup
    },
    data: () => ({
        dialog: false,
        unassignmentDialog:false,
        loading: false,
        assignmentFormData: {
            id: null,
            asset_register_id: null,
            employee_id: null,
            start_date: null,
            remarks: "",
        },
        unassignmentFormData: {
            id: null,
            asset_register_id: null,
            end_date: null,
        },
        assignmentsHeaders: [
            { title: "#SL", align: "center", key: "id", width: "40px", sortable: false },
            { title: "Employee", key: "employee.name", align: "left", sortable: false },
            { title: "Start Date", key: "start_date", align: "left", sortable: false },
            { title: "End Date", key: "end_date", align: "left", sortable: false },
            { title: "Status", key: "status", align: "center", sortable: false },
            { title: "Action", key: "actions", align: "center", sortable: false },
        ],
    }),
    computed: {},
    watch: {},
    created() {},
    methods: {
        openAssetAssignment() {
            this.assignmentFormData = {
                id: null,
                asset_register_id: null,
                employee_id: null,
                start_date: null,
                remarks: "",
            };
            this.dialog = true;
        },
        editAssignment(item) {
            this.assignmentFormData = { ...item };
            this.dialog = true;
        },
        updateAssignmentDate(item) {
            this.unassignmentFormData = { ...item };
            this.unassignmentDialog = true;
        },
    },
    setup(props, {emit}){
        
    },
    mounted() {
        
    },
}
</script>